import { Outlet } from "react-router-dom";
import NavBar from "./Navbar";
import Footer from "./Footer";
const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-1  dark:bg-slate-900 bg-gray-50 ">
        <div className=" mx-auto">
          <Outlet/>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
